// extracted by mini-css-extract-plugin
export default {"control":"ProfileContent_control__9TTRo","flexContainer":"ProfileContent_flexContainer__mMhbP"};